module.exports = __webpack_public_path__ + "static/media/suggestDeliverySpotActionIcon.34c66b26.svg";